<section (window:resize)="onResize($event)" fxLayout="row" class="sen-prevent-text-select h-100" id="roof_panel_container">
   
    <section fxFlex="1 1 77%" id="roof_panel_canvas_container" class="h-100">
        <div  *ngIf="edited" class="panelMove alert alert-success" role="alert" [hidden]="IsmodelShow">
            <div class="moveKey">{{this.panelLayoutMoveKey}}</div>
            <button type="button"      
             class="close" (click)="cardClose()" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
        <div id="panel_canvas_stage"></div>
        <div class="sen-header-panel-zoom text-white font-weight-bold sen-label-font-size px-2 py-1">
            <p>
                <span class="px-2" (click)="zoomInOut('-')">- </span>
                {{translate.getLng('ZOOM')}}
                <span class="px-2" (click)="zoomInOut('+')"> +</span>
            </p>
            <!-- <button mat-raised-button (click)="resetStagePosition()">Reset</button> -->
            <img class="sen-cursor-pointer" src="{{imagePath.PLACE_CENTER}}" width="30" (click)="resetStagePosition(false)">
        </div>
    </section>
    <section fxLayout="column" fxFlex="1 1 25%" class="px-2 sen-tool-bar sen-light-blue-bg">
        <div fxFlex="1 1 auto">
            <h2 class="pl-2 pt-2">{{translate.getLng('PANEL')}}
                <button mat-raised-button class="sen-fs10 float-right" color="primary" (click)="openDialog()">
                    {{translate.getLng('SELECT_PANEL')}}

                </button>
            </h2>
            <h6 class="pl-2 mb-2" title="{{sPanel.name}}" *ngIf="sPanel && sPanel.name">{{translate.getLng('PANEL')}}:
                {{sPanel.name | truncate:20}}</h6>
            <h6 class="pl-2 mb-2">{{translate.getLng('MODCOUNT')}}: {{(panelCount$ | async).count}}
                <span *ngIf="totalKW">({{convertToLocalNumber(totalKW)}} {{translate.getLng('UNIT_KWP')}})</span></h6>
            <!--<table>
                <tr>
                    <td><label class="text-nowrap ml-2">{{translate.getLng('DRAG_MODE')}}</label></td>
                    <td>&nbsp;</td>
                    <td align="right">
                        <mat-slide-toggle color="primary" [checked]="enableDragLayout" (change)="enableDrag()">
                        </mat-slide-toggle>
                    </td>
                </tr>
            </table> -->
            <mat-accordion>
                <mat-expansion-panel [expanded]="collapseIndex == 1" (click)="toolCollapseIndex('1')">
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{translate.getLng('PANEL')}}</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="mod-help mt-2 sen-fs08" fxLayout="row" fxLayoutAlign="center center">
                        <mat-icon class="sen-fs12 sen-small-icon mr-2">info</mat-icon>{{translate.getLng('MOD_HELP')}}
                    </div>
                    <div class="mb-3" fxLayout="row" fxLayoutAlign="center">
                        <div class="mr-3" fxLayout="column" fxLayoutAlign="center center">
                            <div id="draggable" fxLayout="row" fxLayoutAlign="center center">
                                <img width="40" src="./assets/images/mono.jpg" class="dragableContent" />
                                <div (mousedown)="allowPanelonRoof()"></div>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="flex-start center">
                                <img width="25" src="{{imagePath.REMOVE_PANEL_ICON1}}"
                                    title="{{translate.getLng('MOD_REM_SEL')}}" class="sen-cursor-pointer"
                                    (click)="selectedPanelHandler()" />
                                <img width="25" src="{{imagePath.REMOVE_PANEL_ICON2}}"
                                    title="{{translate.getLng('MOD_REM_INV')}}" class="ml-2 sen-cursor-pointer"
                                    (click)="invalidPanel_removeHandler()" />
                                <img width="25" src="{{imagePath.REMOVE_PANEL_ICON3}}"
                                    title="{{translate.getLng('MOD_REM_ALL')}}" class="mx-2 sen-cursor-pointer"
                                    (click)="panel_removeHandler()" />
                            </div>
                        </div>
                        <table class="mt-2 sen-fs10">
                            <tr>
                                <td><label class="mr-5">{{translate.getLng('ROWS')}}</label></td>
                                <td><input type="number" [(ngModel)]="rows" class="border-bottom border-dark text-right"
                                        min="1" max="10" matInput (change)="rowscountHandler()"></td>
                            </tr>
                            <tr>
                                <td><label>{{translate.getLng('COLUMNS')}}</label></td>
                                <td><input type="number" [(ngModel)]="columns"
                                        class="border-bottom border-dark text-right" min="1" max="10" matInput
                                        (change)="columnscountHandler()"></td>
                            </tr>
                            <tr>
                                <td class="pt-3" colspan="2">
                                    <mat-slide-toggle color="primary" (change)="landscapeHandler($event)"
                                        [labelPosition]="'before'">
                                        {{translate.getLng('LANDSCAPE')}}
                                    </mat-slide-toggle>
                                </td>
                            </tr>
                        </table>
                    </div>
                </mat-expansion-panel>
                <mat-expansion-panel [expanded]="collapseIndex == 2" (click)="toolCollapseIndex('2')">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{translate.getLng('STATIC')}}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="sen-fs10">
                        <button class="my-2" mat-raised-button
                            (click)="triggerStatics()">{{translate.getLng('STAT_DETAILS')}}</button>
                        <table *ngIf="(selectedProject$ | async) as project">
                            <tr>
                                <td><img src="{{imagePath.windIcon}}" width="12"> &nbsp;
                                    {{translate.getLng('WINDZONE')}}</td>
                                <td class="px-2">:</td>
                                <td><b>{{project.windZone}}</b></td>
                            </tr>
                            <tr>
                                <td><img src="{{imagePath.snowIcon}}" width="12"> &nbsp;
                                    {{translate.getLng('SNOWZONE')}}</td>
                                <td class="px-2">:</td>
                                <td><b>{{project.snowZone}}</b></td>
                            </tr>
                            <tr>
                                <td><img src="{{imagePath.terrainIcon}}" width="12"> &nbsp;
                                    {{translate.getLng('TERRAIN_CAT')}}
                                </td>
                                <td class="px-2">:</td>
                                <td><b>{{globalF.getInt(project.terrainCategory) + 1}}</b></td>
                            </tr>
                        </table>
                        <mat-slide-toggle class="float-right my-2" color="primary" [labelPosition]="'before'"
                            (change)="toggleBoundaryArea($event)" [checked]="showBoundaryAreaFlag">
                            {{translate.getLng('NORANGE')}}
                        </mat-slide-toggle>
                    </div>
                </mat-expansion-panel>
                <mat-expansion-panel [expanded]="collapseIndex == 3" (click)="toolCollapseIndex('3')">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{translate.getLng('OBSTRUCTIONS')}}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="sen-fs10">
                        <div class="my-2" fxLayout="row" fxLayoutAlign="space-evenly center">
                            <img width="40" src="{{imagePath.NONUSEAREA_SQUARE}}" title="{{translate.getLng('SQUARE')}}"
                                class="sen-cursor-pointer" id="rectangle" (click)="onClickHandlerDraw('rectangle')" />
                            <img width="40" src="{{imagePath.NONUSEAREA_TRIANGLE}}" title="{{translate.getLng('TRIANGLE')}}"
                                class="ml-2 sen-cursor-pointer" id="triangle"
                                (click)="onClickHandlerDraw('triangle')" />
                            <img width="40" src="{{imagePath.NONUSEAREA_CIRCLE}}" title="{{translate.getLng('CIRCLE')}}"
                                class="mx-2 sen-cursor-pointer" id="circle" (click)="onClickHandlerDraw('circle')" />
                            <img width="25" src="{{imagePath.REMOVE_PANEL_ICON1}}"
                                title="Remove the highlighted" class="sen-cursor-pointer"
                                (click)="removeSelectedShapes()" />
                            <img width="25" src="{{imagePath.REMOVE_PANEL_ICON3}}" title="{{translate.getLng('OBSTRUCTIONS_REMOVE')}}"
                                class="mx-1 sen-cursor-pointer" (click)="removeAllShapes()" />
                        </div>

                        <div class="mb-2 sen-fs08" fxLayout="row" fxLayoutAlign="center center">
                            <mat-icon class="sen-fs12 sen-small-icon mr-2">info</mat-icon>
                            {{translate.getLng('NON_USE_AREA_HELP')}}
                        </div>
                        <div class=" w-100 mx-auto my-2">
                            {{translate.getLng('NON_USE_AREA_NAME')}}
                            <div class="w-100" fxLayout="row" fxLayoutAlign="flex-start center">
                                <div fxFlex="1 1 95%">
                                    <table class="mt-2 sen-fs10">
                                        <tr>
                                            <td>
                                                {{translate.getLng('NAME')}}:
                                            </td>
                                            <td>
                                                <input type="text" [(ngModel)]="fenceName"
                                                    class="ml-2 border-bottom border-dark" matInput
                                                    (keyup)="setNameToShape($event)">
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div class="w-100" fxLayout="row" fxLayoutAlign="space-evenly center">
                                <div fxFlex="1 1 57%">
                                    <table class="mt-2 sen-fs10" *ngIf="fenceWidth">
                                        <tr>
                                            <td>
                                                {{translate.getLng('WIDTH')}}:
                                            </td>
                                            <td>
                                                <input type="number" min="0" [(ngModel)]="fenceWidth"
                                                    class="border-bottom text-right border-dark" matInput
                                                    (change)="setSizeToShape($event, 'w')">
                                            </td>
                                            <td>
                                                {{translate.getLng('UNIT_CM')}}
                                            </td>
                                            <td>

                                            </td>
                                        </tr>
                                    </table>
                                    <table class="mt-2 sen-fs10" *ngIf="fenceHeight">
                                        <tr>
                                            <td>
                                                {{translate.getLng('HEIGHT')}}:
                                            </td>
                                            <td>
                                                <input type="number" min="0" [(ngModel)]="fenceHeight"
                                                    class="text-right border-bottom border-dark" matInput
                                                    (change)="setSizeToShape($event,'h')">
                                            </td>
                                            <td>
                                                {{translate.getLng('UNIT_CM')}}
                                            </td>
                                            <td>

                                            </td>
                                        </tr>
                                    </table>
                                    <table class="mt-2 sen-fs10" *ngIf="fenceX1">
                                        <tr>
                                            <td>
                                                X1:{{translate.getLng('X_AXIS')}}
                                            </td>
                                            <td>
                                                <input type="number" min="0" [(ngModel)]="fenceX1"
                                                    class="border-bottom border-dark text-right" matInput
                                                    (change)="setSizeToShape($event, 'x1')">
                                            </td>
                                            <td>
                                                {{translate.getLng('UNIT_CM')}}
                                            </td>
                                        </tr>
                                    </table>
                                    <table class="mt-2 sen-fs10" *ngIf="fenceX2">
                                        <tr>
                                            <td>
                                                X2:{{translate.getLng('X_AXIS')}}
                                            </td>
                                            <td>
                                                <input type="number" min="0" [(ngModel)]="fenceX2"
                                                    class="border-bottom border-dark text-right" matInput
                                                    (change)="setSizeToShape($event, 'x2')">
                                            </td>
                                            <td>
                                                {{translate.getLng('UNIT_CM')}}
                                            </td>
                                        </tr>
                                    </table>
                                    <table class="mt-2 sen-fs10" *ngIf="fenceX3">
                                        <tr>
                                            <td>
                                                X3:{{translate.getLng('X_AXIS')}}
                                            </td>
                                            <td>
                                                <input type="number" min="0" [(ngModel)]="fenceX3"
                                                    class="border-bottom border-dark text-right" matInput
                                                    (change)="setSizeToShape($event, 'x3')">
                                            </td>
                                            <td>
                                                {{translate.getLng('UNIT_CM')}}
                                            </td>
                                        </tr>
                                    </table>
                                    <table class="mt-2 sen-fs10" *ngIf="fenceRadius">
                                        <tr>
                                            <td>
                                                {{translate.getLng('RADIUS')}}:
                                            </td>
                                            <td>
                                                <input type="number" min="0" [(ngModel)]="fenceRadius"
                                                    class="text-right border-bottom border-dark" matInput
                                                    (change)="setSizeToShape($event, 'r')">
                                            </td>
                                            <td>
                                                {{translate.getLng('UNIT_CM')}}
                                            </td>
                                            <td>

                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <mat-divider class="border-black mx-2" [vertical]="true"></mat-divider>
                                <div fxFlex="1 1 37%">
                                    <table class="mt-2 sen-fs10" *ngIf="fenceX">
                                        <tr>
                                            <td>
                                                X:{{translate.getLng('X_AXIS')}}
                                            </td>
                                            <td>
                                                <input type="number" min="0" [(ngModel)]="fenceX"
                                                    class="border-bottom border-dark text-right" matInput
                                                    (change)="setSizeToShape($event, 'x')">
                                            </td>
                                            <td>
                                                {{translate.getLng('UNIT_CM')}}
                                            </td>
                                        </tr>
                                    </table>
                                    <table class="mt-2 sen-fs10" *ngIf="fenceY">
                                        <tr>
                                            <td>
                                                Y:{{translate.getLng('Y_AXIS')}}
                                            </td>
                                            <td>
                                                <input type="number" min="0" [(ngModel)]="fenceY"
                                                    class="border-bottom border-dark text-right" matInput
                                                    (change)="setSizeToShape($event, 'y')">
                                            </td>
                                            <td>
                                                {{translate.getLng('UNIT_CM')}}
                                            </td>
                                        </tr>
                                    </table>

                                    <table class="mt-2 sen-fs10" *ngIf="fenceY1">
                                        <tr>
                                            <td>
                                                Y1:{{translate.getLng('Y_AXIS')}}
                                            </td>
                                            <td>
                                                <input type="number" min="0" [(ngModel)]="fenceY1"
                                                    class="border-bottom border-dark text-right" matInput
                                                    (change)="setSizeToShape($event, 'y1')">
                                            </td>
                                            <td>
                                                {{translate.getLng('UNIT_CM')}}
                                            </td>
                                        </tr>
                                    </table>

                                    <table class="mt-2 sen-fs10" *ngIf="fenceY2">
                                        <tr>
                                            <td>
                                                Y2:{{translate.getLng('Y_AXIS')}}
                                            </td>
                                            <td>
                                                <input type="number" min="0" [(ngModel)]="fenceY2"
                                                    class="border-bottom border-dark text-right" matInput
                                                    (change)="setSizeToShape($event, 'y2')">
                                            </td>
                                            <td>
                                                {{translate.getLng('UNIT_CM')}}
                                            </td>
                                        </tr>
                                    </table>

                                    <table class="mt-2 sen-fs10" *ngIf="fenceY3">
                                        <tr>
                                            <td>
                                                Y3:{{translate.getLng('Y_AXIS')}}
                                            </td>
                                            <td>
                                                <input type="number" min="0" [(ngModel)]="fenceY3"
                                                    class="border-bottom border-dark text-right" matInput
                                                    (change)="setSizeToShape($event, 'y3')">
                                            </td>
                                            <td>
                                                {{translate.getLng('UNIT_CM')}}
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
                <mat-expansion-panel class="sen-overflow-visible" [expanded]="collapseIndex == 4"
                    (click)="toolCollapseIndex('4')">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{translate.getLng('VIEWS')}}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <table class="m-auto sen-fs10 w-75">
                        <ng-container *ngIf="!globalF.checkIntegratedRoof()">
                            <tr>
                                <td><label class="text-nowrap">{{translate.getLng('BEAM_COLOR')}}</label></td>
                                <td align="right"><span class="sen-color-picker ml-5 border-dark d-block"
                                        [cpPosition]="'bottom-left'" [(colorPicker)]="beamColorCode"
                                        (colorPickerChange)="onchangeBeamColor(beamColorCode)"
                                        [style.background]="beamColorCode"></span></td>
                            </tr>
                            <tr>
                                <td><label class="text-nowrap">{{translate.getLng('BEAM_SHOW_TEXT')}}</label></td>
                                <td align="right">
                                    <mat-slide-toggle color="primary" [checked]="showBeamsFlag"
                                        (change)="onChangeShowBeam($event)">
                                    </mat-slide-toggle>
                                </td>
                            </tr>
                        </ng-container>
                        <tr>
                            <td><label class="text-nowrap pt-2">{{translate.getLng('MOD_TRANSP')}}</label></td>
                            <td align="right">
                                <mat-slider thumbLabel tickInterval="1" min="0" max="90"
                                    (change)="onChangeTransparency($event)" value="0" [disabled]="!showPanelsFlag">
                                </mat-slider>
                            </td>
                        </tr>
                        <tr>
                            <td><label class="text-nowrap pt-2">{{translate.getLng('MOD_SHOW')}}</label></td>
                            <td align="right">
                                <mat-slide-toggle color="primary" [checked]="showPanelsFlag"
                                    (change)="onChangeShowPanel($event)">
                                </mat-slide-toggle>
                            </td>
                        </tr>
                        <tr>
                            <td><label class="text-nowrap pt-2">{{translate.getLng('OBSTRUCTIONS_SHOW')}}</label></td>
                            <td align="right">
                                <mat-slide-toggle color="primary" [checked]="showNonUsesFlag"
                                    (change)="onChangeOfShowNonUsesFlag($event)">
                                </mat-slide-toggle>
                            </td>
                        </tr>
                        <tr>
                            <td><label class="text-nowrap pt-2">{{translate.getLng('SCAFFOLD_SHOW')}}</label></td>
                            <td align="right">
                                <mat-slide-toggle color="primary" [checked]="subframeToggleBtn"
                                    (click)="checkEllipseError($event)" id="subframeToggleBtn"
                                    (change)="onChangeSubFrameHandler($event)">
                                </mat-slide-toggle>
                            </td>
                        </tr>
                        <tr>
                            <td><label class="text-nowrap pt-2">{{translate.getLng('PROFILE_CUT_LIST')}}</label></td>
                            <td align="right">
                                <mat-slide-toggle color="primary" [checked]="cutProfileToggleBtn"
                                    (click)="checkEllipseError($event)" id="cutProfileToggleBtn"
                                    (change)="onChangeCutProfileHandler($event)">
                                </mat-slide-toggle>
                            </td>
                        </tr>
                       <!-- <tr>
                        <td><label>Cut Profile Len</label></td>
                            <td><input type="number" [(ngModel)]="cutProfileLen"
                                    class="border-bottom border-dark text-right" min="1" max="150" matInput
                                    (change)="onChangeCutProfileLen()"></td>

                         </tr>  -->              
                    </table>
                </mat-expansion-panel>
                <mat-expansion-panel *ngIf="varietyProfile" [expanded]="collapseIndex == 5"
                    (click)="toolCollapseIndex('5')">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{translate.getLng('PROFILE_SELECTION')}}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="sen-fs10 my-2">
                        <p>{{translate.getLng('SELECTED')}} : {{sHprofile}}</p>
                        <button [disabled]="!(panelCount$ | async).count" (click)="triggerProfiles()"
                            class="d-block m-auto sen-fs10"
                            mat-raised-button>{{translate.getLng('VARIETY_PROFILE')}}</button>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
        <!-- <button class="my-2" mat-raised-button
                            (click)="drawMesurments()">draw</button>
                            <button class="my-2" mat-raised-button
                            (click)="subframeMesurment()">subframe</button> -->
        <div class="my-2" fxLayout="row" fxLayoutAlign="space-evenly center">
            <button class="px-5 py-2" (click)="goPrev()" mat-raised-button
                color="primary">{{translate.getLng('PREV')}}</button>
            <button class="px-5 py-2" [disabled]="enableNextBtn" (click)="goNext1()" mat-raised-button
                color="primary">{{translate.getLng('NEXT')}}</button>
        </div>
        

             <!-- start profile cut list modal-->
        <!-- Button trigger modal -->
        <button type="button" class="btn btn-primary d-none  profile-cutlist" data-toggle="modal" data-target="#cutlistModal">
            Launch 
            </button>
    
            <!-- Modal -->
            <div class="modal fade " id="cutlistModal" tabindex="-1" role="dialog" aria-labelledby="cutlistModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false" cdkDrag>
                <div class="modal-dialog modal-lg" role="document" >
                    <div class="modal-content " >
                    <div class=" row" style="padding: 10px;" cdkDragHandle>
                        <div class="col-11" >
                            <h5 class="modal-title  pt-1 pl-2" id="cutlistModalLabel" style="font-size: 18px;" >{{translate.getLng('PROFILE_CUT_LIST')}}</h5>
                        </div>
                        <div class="col" >
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click) = "removeSubFrameProfileCut()">
                                <span aria-hidden="true">&times;</span>
                                </button>
                        </div>
                        
                            <div class="sen-fs10 pr-4 ml-3 pt-2">
                                <label>{{translate.getLng('PROFILE_CUT_MIN')}} </label>
                                    <input type="number" [(ngModel)]="cutProfileLen"
                                            class="border-bottom border-dark text-right cutlen" min="10" max="200" 
                                           (change) = "checkCutProfileLen()" >
                                <label class="pl-4  ">{{translate.getLng('PROFILE_CUT_LENGTH')}} = </label>{{iProfileLen}} cm
        
                             </div>   
                              
                         
                       
                        
                       
                    </div>
                    
                    <div>
                        <table class="table table-hover mb-0" >
                            <thead class="thead-light"> 
                              <tr>
                                <th class = "col-10" style="font-size: 15px;">Name</th>
                                <th lass = "col" style="font-size: 15px;">{{translate.getLng('PROFILE_CUTS')}}</th>
                              </tr>
                        </thead>
                    </table>
                    
                    </div>
                    <div class="modal-body p-0 table-responsive">
                        <table class="table table-hover " >
                            <tbody>
                              <tr *ngFor="let cuts of cutlistGroup">
                                <td class="sen-fs10 col-10" >{{cuts.name}}</td>
                                <td class="sen-fs10 col">{{cuts.cut}}</td>
                              </tr>
                              
                             
                            </tbody>
                          </table>
                          
                    </div>
                    <div class="modal-footer">
                        
                        <button type="button" class="btn btn-primary" data-dismiss="modal" (click)= "onChangeCutProfileLen()">OK</button>
                    </div>
                    </div>
                </div>
                </div>
                <!-- end profile cut list modal-->
        
    </section>
   
       
   
</section>
